import React from 'react'
import { Box, Dialog, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useTenant } from '@emerald-works-nova/auth'
import TenantLogo from '../../../tenant-logo'

const useStyles = makeStyles(
  ({ typography, spacing, palette, breakpoints }) => ({
    content: {
      width: 620,
      height: 435,
      [breakpoints.down(700)]: {
        maxWidth: '100%'
      }
    },
    logo: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: spacing(10),
      marginBottom: spacing(6)
    },
    title: {
      ...typography.heading.h4,
      fontWeight: typography.fontWeightMedium
    }
  })
)

const Updating = ({ open }) => {
  const classes = useStyles()
  const tenant = useTenant()

  return (
    <Dialog
      open={open}
      maxWidth={false}
      aria-labelledby='updating-dialog-title'
    >
      <Box className={classes.content}>
        <TenantLogo tenant={tenant} height={75} className={classes.logo} mtLogo='mt-club' />
        <Typography
          variant='h5'
          component='h1'
          align='center'
          id='updating-dialog-title'
          className={classes.title}
        >
          Enhancing Your Experience
        </Typography>
      </Box>
    </Dialog>
  )
}

export default Updating
